import { commonFilterOptions } from 'utils/dateRangeFilterOptions';

export const STATUS = {
  COMPLETE: 'COMPLETE',
  COMPLETED_WITH_ERRORS: 'COMPLETED_WITH_ERRORS',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
};

/**
 * To check if an import job is done or not
 * @param {string} status
 * @returns {boolean}
 */
export const isFinished = status => {
  const upperStatus = status.toUpperCase();
  return upperStatus === STATUS.COMPLETE || upperStatus === STATUS.FAILED;
};

/**
 * To check in current status of import is equal to a expected status
 * @param {string} expected
 * @param {string} actual
 * @returns {boolean}
 */
export const isSameStatus = (expected, actual) =>
  expected.toUpperCase() === actual.toUpperCase();

export const ONBOARDING_NOTIFICATION_SENDING = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  DISABLED_NO_PERMISSION: 'DISABLED_NO_PERMISSION',
  DISABLED_NO_USERS: 'DISABLED_NO_USERS',
};

export const DATE_FILTER_OPTIONS = [
  commonFilterOptions.ALL_DATES,
  commonFilterOptions.PAST_7DAYS,
  commonFilterOptions.PAST_30DAYS,
  commonFilterOptions.PAST_60DAYS,
  commonFilterOptions.PAST_90DAYS,
  commonFilterOptions.DATE_RANGE,
];
